<template>
  <li>
    <a :href="url" :title="item.name" :target="isBlank" :class="className" @click="toggle">{{ item.name }}</a>

    <transition
      v-if="isChildren"
      name="nested"
      @before-enter="beforeEnter"
      @enter="enter"
      @before-leave="beforeLeave"
      @leave="leave"
    >
      <ul v-show="collapse" class="nested">
        <MenuMemberList v-for="(child, index) in item.children" :key="index" :item="child" />
      </ul>
    </transition>

    <span v-if="item.new" class="new">NEW</span>
  </li>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'menu-member-list',
  components: {
    MenuMemberList: () => import('./MenuMemberList'),
  },

  props: {
    item: { type: Object, default: () => {} },
  },

  data() {
    return {
      collapse: true,
    };
  },

  computed: {
    ...mapState(['SOCIOLLA_WEB_URL', 'BJ_WEB_URL', 'SOCO_WEB_URL', 'REVIEW_WEB_URL', 'LULLA_WEB_URL', 'userProfile']),

    isChildren() {
      return this.item.children && this.item.children.length;
    },

    isBlank() {
      // exclude current url
      return this.item.key ? (this.item.key.indexOf('BJ_WEB_URL') > -1 ? false : '_blank') : false;
    },

    url() {
      // destruct
      const { key } = this.item;
      let { path } = this.item;

      if (key) {
        // include username
        path = path.indexOf('/timeline') > -1 ? '/' + this.userProfile.user_name : path;

        return this[key] + path;
      }

      return 'javascript:';
    },

    className() {
      return {
        [this.item.icon]: this.item.icon,
        collapse: this.collapse,
      };
    },
  },

  methods: {
    toggle() {
      if (this.item.url) {
        this.$store.commit('closeOffCanvas');
        if (this.$SO.size(this.userProfile)) {
          if (Boolean(this.userProfile.beauty && this.userProfile.beauty.length)) {
            this.$router.push('/our-curated-selection');
          } else {
            this.$store.commit('toggleModalGlobalState', {
              modalName: 'confirmBP',
            });
          }
        } else {
          this.$store.commit('modalAuth', 1);
        }
      }
      if (this.isChildren) {
        this.collapse = !this.collapse;
      }
    },

    beforeEnter(el) {
      el.style.height = 0;
    },

    enter(el) {
      el.style.height = el.scrollHeight + 'px';
    },

    beforeLeave(el) {
      el.style.height = el.scrollHeight + 'px';
      getComputedStyle(el).height; // force repaint
    },

    leave(el) {
      el.style.height = 0;
    },
  },
};
</script>
